import {STATES} from 'common/domain/states';

export default class NetworkService {
  constructor($window, $state, $translate, $q) {
    'ngInject';
    this.window = $window;
    this.state = $state;
    this.translate = $translate;
    this.isOffline = false;
    this.q = $q;
    this.translate('GLOBALS.NETWORK_ERROR').then(translation => this.message = translation);
  }

  run() {
    this.window.addEventListener('online', () => this.online());
    this.window.addEventListener('offline', () => this.offline());

    if (this.window.navigator && this.window.navigator.onLine === false) {
      this.offline();
    }
  }

  networkInformationPluginAvailable() {
    return !!(this.window && this.window.navigator);
  }

  offline() {
    this.isOffline = true;
  }

  checkNetworkStatus() {
    if(this.isOffline){
      this.state.go(STATES.ERROR, {errorMessage: this.message});
    }
  }

  online() {
    if (this.isOffline) {
      this.isOffline = false;
      this.window.history.back();
    }
  }

}



// WEBPACK FOOTER //
// ./client/app/common/services/network.service.js